import Header from '../../components/feature/Header';
import HeroSection from './components/HeroSection';
import MolecularIdentificationSection from './components/MolecularIdentificationSection';
import WorkflowSection from './components/WorkflowSection';
import ServicesSection from './components/ServicesSection';
import MarketSegmentsSection from './components/MarketSegmentsSection';
import LumusSection from './components/LumusSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-crop-white font-gilroy">
      <Header />
      <HeroSection />
      <MolecularIdentificationSection />
      <WorkflowSection />
      <ServicesSection />
      <MarketSegmentsSection />
      <LumusSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
}